<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" key="deleteProfile"></p-confirmDialog>
<div class="confirmation alert alert-danger">
  You are currently logged in as {{displayName}}. Click the button below if you would like to delete your profile
  completely from Accord.
</div>
<div class="delete-user-button">
  <a (click)="deleteUser()" class="btn">Delete Profile</a>
</div>
